<template lang="html">
	<section id="privacy" class="copyblock">
		<h1>Privacy Policy</h1>
		<p>This website does not collect personally identifiable information from visitors or use any third-party tracking.</p>
		<p>We do use a cookie to store a local ID used to know if you have visited the site before in order to retrieve your submitted writing responses on subsequent visits.</p>
		<p>All written responses are anonymous - we do not store IP addresses or email addresses. Written responses are linked to the unique ID stored in your cookie and are only retrieved when shared directly or when you visit the site with the cookie intact. If you clear your cookies you will not be able to retrieve your previous written responses.</p>
		<p>Written response content may be used in future data visualizations, artistic works, or basic analysis. They will remain anonymous and will never be shared in their original form unless you share them via the direct URL to your response, or otherwise by copying the text.</p>
		<p>By participating in the written responses, you agree to your response possibly being used as stated above.</p>
	</section>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
